exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".horizontal-scrolling-wrapper{display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;overflow-x:auto}.horizontal-scrolling-wrapper .card{-ms-flex:0 0 auto;flex:0 0 auto;min-width:100%}", "", {"version":3,"sources":["/opt/build/repo/src/components/pages/TestPage.vue"],"names":[],"mappings":"AACA,8BACE,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,iBAAkB,AACtB,eAAiB,CAClB,AACD,oCACE,kBAAmB,AACf,cAAe,AACnB,cAAc,CACf","file":"TestPage.vue","sourcesContent":["\n.horizontal-scrolling-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  overflow-x: auto;\n}\n.horizontal-scrolling-wrapper .card {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  min-width:100%\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42b78caa","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/TestPage.vue
// module id = 1609
// module chunks = 1